export default "__VITE_ASSET__CmWTNmY5__"